import { useSelector, TypedUseSelectorHook, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { onChecking, onLogin, onLogout, RootState } from '../../store';
import * as UseCases from '../../../core/use-cases';
import { fintraceApiFetcher } from '../../../config/fintrace-api.adapter';

interface LoginProps {
  email: string;
  password: string;
  tokenCloudflare?: string;
}

// Definir un hook tipado para useSelector
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

// Asegúrate de que el estado auth en el Redux store incluya 'checking' como posible status

export const useAuthStore = () => {
  const { status, user, errorMessage } = useTypedSelector(
    (state) => state.auth
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const startLogin = async (credentials: LoginProps) => {
    dispatch(onChecking());
    try {
      const response = await UseCases.LoginUserUseCases(
        fintraceApiFetcher,
        credentials
      );

      dispatch(onLogin(response));

      return response;
    } catch (error: any) {
      console.log(error);
      dispatch(onLogout(error.message));
    }
  };

  const checkAuthToken = async () => {
    try {
      const response = await UseCases.RefreshTokenUseCases(fintraceApiFetcher);
      dispatch(onLogin(response));

      // Solo redirigimos a general si estamos en una ruta de autenticación
      if (location.pathname.startsWith('/auth/')) {
        navigate('/dashboard/general');
      }
    } catch {
      dispatch(onLogout());
    }
  };

  const startLogout = async (email: string) => {
    try {
      await UseCases.LogoutUseCases({ username: email }, fintraceApiFetcher);
      dispatch(onLogout());
    } catch {
      dispatch(onLogout());
    }
  };

  return {
    //properties
    status,
    user,
    errorMessage,

    //methods
    startLogin,
    checkAuthToken,
    startLogout,
  };
};
